module.exports = __webpack_public_path__ + "e808a353.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/videos2.png
// module id = 1340
// module chunks = 6